import { FormControl } from '@angular/forms';

declare module '@angular/forms' {
  interface FormControl {
    pvscAdditionalData: PVSCAdditionalData;
  }
}
Object.defineProperty(FormControl.prototype, 'pvscAdditionalData', {
  get: function () {
    const data = pvscAdditionalDataMap.get(this);
    if (!data) {
      pvscAdditionalDataMap.set(this, {});
    }
    return pvscAdditionalDataMap.get(this);
  },
  set: function (value: PVSCAdditionalData) {
    pvscAdditionalDataMap.set(this, value);
  },
});

export interface PVSCAdditionalData {
  fileType?: string;
  fileSizeInMB?: number;
}

const pvscAdditionalDataMap = new WeakMap<FormControl, PVSCAdditionalData>();
